import React, { memo, useEffect } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { createStructuredSelector } from "reselect";
import get from "lodash/get";
import {
  clearData,
  createInitialOrder,
  doKyc,
  activateSimCard
} from "ducks/actions";
import {
  makeSelectIsFetchingData,
  makeSelectIsFetchingAnyData,
  makeSelectOrder,
  makeSelectOrderRef,
  makeSelectOrderParams,
  makeSelectPageValidations,
  makeSelectKycParams,
  makeSelectDocTypes,
  makeSelectWorkflow
} from "ducks/selectors";
import SmartRender from "containers/SmartRender";
import { forms, paths, STEP_ACTIONS } from "utils/constants";
import { handleOnLoadAction, goBack, gotoUrl } from "utils/helpers";
import Spinner, { styles } from "components/Spinner";
import validate from "validations";
import isEmpty from "lodash/isEmpty";
import { isActivationSuccess, setOrderId } from "utils/localStorage";

const VerifyIdentityHOC = Component =>
  function Comp(props) {
    const { isFetchingAnyData } = props;

    useEffect(
      () => {
        !isActivationSuccess() && handleOnLoadAction(props);
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      []
    );

    return isFetchingAnyData ? (
      <Spinner size={200} sx={styles.fullPage} />
    ) : (
      <Component {...props} />
    );
  };

const mapStateToProps = (_, props) =>
  createStructuredSelector({
    formValidations: makeSelectPageValidations(
      forms.IDENTITY_VERIFICATION_FORM
    ),
    payload: makeSelectKycParams(),
    docTypes: makeSelectDocTypes(),
    order: makeSelectOrder(),
    orderRef: makeSelectOrderRef(),
    orderParams: makeSelectOrderParams(get(props, "match.params.channel")),
    isCreatingOrder: makeSelectIsFetchingData("order"),
    isFetchingAnyData: makeSelectIsFetchingAnyData(),
    workflow: makeSelectWorkflow()
  });

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  createInitialOrder: () => {
    dispatchProps.createInitialOrder(stateProps.orderParams);
  },
  verifyOrder: () => {
    const { orderRef } = stateProps;
    if (!orderRef) {
      gotoUrl(paths.MANAGE_ORDER, true, {
        redirect: STEP_ACTIONS.ACTIVATE_SIM_CARD
      });
    } else {
      setOrderId(orderRef);
    }
  }
});

export function mapDispatchToProps(dispatch) {
  return {
    clearOrder: () => {
      dispatch(clearData("order"));
    },
    createInitialOrder: orderParams => {
      if (!isEmpty(orderParams)) {
        dispatch(
          createInitialOrder(orderParams, (order, error) => {
            if (!isEmpty(error)) {
              goBack();
            } else {
              setOrderId(get(order, "order_ref", ""));
            }
          })
        );
      }
    },
    doKyc: (navigate, payload) => {
      dispatch(
        doKyc(payload, (_, error) => {
          if (isEmpty(error)) {
            console.log("Sim registration success. Clear Order ");
            dispatch(clearData("order"));
            navigate();
          }
        })
      );
    },
    activateSimCard: (navigate, payload) => {
      dispatch(
        activateSimCard(payload, (_, error) => {
          if (isEmpty(error)) {
            console.log("Sim Activation success.");
            navigate();
          }
        })
      );
    }
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps, mergeProps);
export default compose(
  withConnect,
  reduxForm({
    form: forms.IDENTITY_VERIFICATION_FORM,
    destroyOnUnmount: false,
    validate
  }),
  memo
)(VerifyIdentityHOC(SmartRender));
